import type { LocationSummary } from "../page";

interface TodaySummaryCardProps {
  summary: LocationSummary;
}

const TodaySummaryCard = ({ summary }: TodaySummaryCardProps) => {
  const items = [
    { label: "위치 대상", count: summary.totalCount, dot: "bg-blue-500" },
    { label: "정상 수신", count: summary.normalCount, dot: "bg-emerald-500" },
    { label: "확인 필요", count: summary.checkNeededCount, dot: "bg-orange-500" },
    { label: "지연/미수신", count: summary.staleCount, dot: "bg-slate-400" },
  ];

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
      <div className="flex items-center gap-2 mb-3">
        <i className="ri-bar-chart-line text-sm text-slate-500" />
        <h3 className="text-sm font-semibold text-slate-700">위치 수신 현황</h3>
      </div>
      <div className="space-y-2.5">
        {items.map((item) => (
          <div key={item.label} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className={`inline-block w-1.5 h-1.5 rounded-full ${item.dot}`} />
              <span className="text-xs text-slate-600">{item.label}</span>
            </div>
            <span className="text-xs font-semibold text-slate-800">{item.count}건</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TodaySummaryCard;
